import React from "react";

import { useDetectAdBlock } from "adblock-detect-react";

import CreativeAsset from "@assets/creative-asset.svg";
import { Creative, type CreativeAdType } from "@components/creatives";
import { type GetCampaign_me_adObject } from "@north-beam/nb-client-side";

interface CreativeAssetSectionInterface {
  adObject: GetCampaign_me_adObject;
}
export const CreativeAssetSection = ({
  adObject,
}: CreativeAssetSectionInterface) => {
  const adBlockDetected = useDetectAdBlock();
  const creatives: undefined | CreativeAdType[] =
    adObject?.creativesData?.creatives;

  if (!creatives || !creatives.length) {
    return null;
  }

  return (
    <div className="py-2">
      <div className="flex items-center">
        <div className="mr-2">
          <img className="w-4" alt="Creative Asset" src={CreativeAsset} />
        </div>
        <div className="text-lg text-gray-900">Creative Asset</div>
      </div>
      {adBlockDetected && (
        <small>
          <em>
            If your creative is not displaying, try turning off your adblocker.
          </em>
        </small>
      )}
      {creatives.map((creative: any, index: number) => {
        return <Creative ad={creative} key={index} />;
      })}
    </div>
  );
};
